// extracted by mini-css-extract-plugin
export default {"root":"style_root__arfy5","icon":"style_icon__yZTpX","label":"style_label__f3O8u"};